import { makeObservable, observable } from "mobx";

class AudioPlayerModel {
    audioPlayer: HTMLAudioElement | null = null;
    currentTime: number = 0;
    duration: number = 0;

    audioBlob: Blob | null = null;
    constructor() {
        makeObservable(this, {
            audioPlayer: observable,
            currentTime: observable,
            duration: observable,
            audioBlob: observable,
        })
    }
    loadBlob(blob: Blob) {

        // remove event listeners
        if (this.audioPlayer) {
            this.audioPlayer.removeEventListener('timeupdate', () => {
                if (this.audioPlayer) {
                    this.currentTime = this.audioPlayer.currentTime;
                    this.duration = this.audioPlayer.duration;
                }
            });
        }

        const fileURL = URL.createObjectURL(blob);
        this.audioBlob = blob;
        this.audioPlayer = new Audio(fileURL);
        this.audioPlayer.volume = 1;

        if (this.audioPlayer) {
            this.audioPlayer.addEventListener('timeupdate', () => {
                if (this.audioPlayer) {
                    this.currentTime = this.audioPlayer.currentTime;
                    this.duration = this.audioPlayer.duration;
                }
            });
        }

    }
    play() {
        if (this.audioPlayer) {
            this.audioPlayer.play();
        }
    }
    pause() {
        if (this.audioPlayer) {
            this.audioPlayer.pause();
        }
    }
    stop() {
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer.currentTime = 0;
        }
    }
    rewind() {
        if (this.audioPlayer) {
            this.audioPlayer.currentTime = 0;
        }
    }
}

const audioPlayerModel = new AudioPlayerModel();
export default audioPlayerModel